// extracted by mini-css-extract-plugin
module.exports = {"dashboardCont":"Dashboard_dashboardCont__PyYlk","dashboardContSidebar":"Dashboard_dashboardContSidebar__11g1w","dashboardContMain":"Dashboard_dashboardContMain__2uGll"};